<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table th>.cell {
    white-space: pre-wrap;
  }
  a {
    color: #333333;
    text-decoration: none;
  }
  a:hover{
    color: #1890ff;
    text-decoration: none;
  }
</style>
<template>
<div>
  <HeaderView></HeaderView>
  <NavigateView></NavigateView>
  <BannerView></BannerView>
  <div v-bind:style="{minHeight: height+'px'}" style="width: 980px; margin: 0 auto;" >
    <template>
      <el-tabs v-model="active" type="card" @tab-click="handleClick">
        <el-tab-pane name="bargain">
          <template #label>
            <span><i class="el-icon-connection"></i> 在线报价</span>
            <!-- <el-badge :value="declareResult.goodsNum" class="item"></el-badge> -->
          </template>
          <el-form ref="bargainform" :model="bargainform" label-width="80px">
          </el-form>
          <!-- <el-alert :closable="false" title="工作提示：" type="info" show-icon style="margin-bottom: 15px; width: 980px;">
            <p>&emsp;材料申报所含三项内容（质量评价、价格填报、历史履约情况调查表）应在申报截止日期（7月13日）前完成。</p>
          </el-alert> -->
          <el-table :data="bargainform.data" border style="width: 100%" max-height=450 size="mini" @cell-mouse-leave="showClickIcon=false" :row-key="getRowKeys" ref="tableRef">
            <el-table-column fixed="left" type="index" label="序号" width="50" align='center' rowspan=2></el-table-column>
            <el-table-column prop="code" label="统编代码" width="115" align='center'></el-table-column>
            <el-table-column prop="drugName" label="通用名" width="150" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="drugDosage" label="剂型" width="80" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="packageSpecific" label="包装规格" align='center' :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="producerName" label="生产企业" width="140" align='center' :show-overflow-tooltip='true'></el-table-column>
            <!-- <el-table-column prop="winPrice" label="中选价格(元)" :formatter="thousandth" width="100" align='right' v-if="8 == bargainform.status"></el-table-column> -->
            <el-table-column align="center">
              <template slot="header">
                <!-- <div>议价填报（GPO）</div><div>降幅和GPO议价价格必填，有小数则保留两位。</div> -->
                <div>议价填报（单位：元）</div><div>价格信息必填，集中议价报价不高于阳光平台挂网价。</div>
              </template>
              <el-table-column prop="discount" :label="'阳光平台挂网价'" :formatter="thousandth" align='center' width="120">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.privatePrice" :disabled="'true' === scope.row.disabled" style="width: 80px;" placeholder="请填写"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="declarePrice" :label="'集中议价报价'" :formatter="thousandth" align='center' width="120">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.declarePrice" :disabled="'true' === scope.row.disabled" style="width: 80px;" placeholder="请填写"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="operator" :label="'操作'" width="75" align="center">
                <template slot-scope="scope">
                  <template v-if="'true' === scope.row.disabled">
                    <div style="font-size: 13px; cursor: pointer; color: #1890ff;" @click="scope.row.disabled = 'false'">
                      <i class="el-icon-edit" style="font-size: 16px; font-weight: 500;" title="填报"></i><span>填报</span>
                    </div>
                  </template>
                  <template v-if="'false' === scope.row.disabled">
                    <div style="font-size: 13px; cursor: pointer; color: #67C23A;" @click="submitDiscount(scope.row)">
                      <i class="el-icon-finished" style="font-size: 16px; font-weight: 500;" title="保存"></i><span>保存</span>
                    </div>
                  </template>
                </template>
              </el-table-column>
            </el-table-column>

            <!-- <el-table-column prop="discount" :label="'降幅(%)\n（示例：填写5.25，表示填报降幅为5.25%）'" :formatter="thousandth" align='center'>
              <template slot-scope="scope">
                <template v-if="scope.row.edit">
                  <el-tag plain v-if="scope.row.discount">{{ scope.row.discount }}</el-tag>&emsp;<i class="el-icon-edit" style="font-size: 16px; font-weight: 400; color: #1890ff; cursor: pointer;" title="修改" @click="scope.row.edit = false"></i>
                </template>
                <template v-else>
                  <el-input size="mini" v-model="scope.row.discount" style="width: 60px;" placeholder="请填写价格降幅" @blur="checkDiscount(scope.row)" slot="reference"></el-input>
                  <el-link type="primary" :underline="false" style="font-size: 11px;" @click="submitDiscount(scope.row)">&nbsp;&nbsp;提交</el-link>
                </template>
              </template>
            </el-table-column> -->
            <!-- <el-table-column fixed="right" prop="statusDesc" label="重新议价说明" width="150" align='center'></el-table-column> -->
            <!-- <el-table-column fixed="right" label="操作" width="120" align='center'>
              <template #default="scope">
                <el-button @click="operate = true; handleClick(scope.row, scope.row.fn)" :type="scope.row.btnType" v-if="scope.row.fn" size="mini" plain>{{scope.row.operate}}</el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination @size-change="(val) => handlePagination(null, val, 'bargainform')" @current-change="(val) => handlePagination(val, null, 'bargainform')" @prev-click="(val) => handlePagination(val, null, 'bargainform')" @next-click="(val) => handlePagination(val, null, 'bargainform')"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="bargainform.pageNo"
            :page-sizes="bargainform.pageSizes" :page-size="bargainform.pageSize" :total="bargainform.total">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>

  <FooterView></FooterView>
</div>

</template>
<script>
  export default {
    name: 'mydeclare',
    data(){
      var validateValid = (rule, value, callback) => {
        if(0 > Number(value)) {
          callback(new Error('请输入大于0的数字（两位小数）'));
        }else{
          // if(this.ruleForm.checkPass !== ''){
          //   this.$refs.ruleForm.validateField('checkPass');
          // }
          callback();
        }
      };
      var validateRate = (rule, value, callback) => {
        if(0 >= Number(value)){
          callback(new Error('还款比例应大于0'));
        }else{
          callback();
        }
      };

      return {
        active: 'bargain',
        height: 0,
        operate: false,
        operator: 0,
        changed: '',
        submitButtonLoading: false,
        btnActive: [true, false, false, false, false, false, false, false],
        activeName: '',
        tabPosition: 'left',
        declareResult: null,
        captchaUrl: '',
        uploadImgUrl: '',
        offerUploadUrl: '',
        fileListOfferFile: [],
        fileListfddbrsqzsImg:[],
        //不用审核直接可以质量评级、在线报价 原 bargainform.status: 5
        bargainform: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50], fn: 'getProductPage', status: 2
        },
        bargainOnlineForm: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50], fn: 'getBargainOnlinePage', stype: 'OFFERONLINE'
        },
        assessPwd: {
          pass: '',
          checkPass: '',
        },
        //不用审核直接可以质量评级、在线报价 queryform.status: 3
        queryform: {
          data: [], total: 0, pageNo: 1, pageSize: 10, pageSizes: [10, 20, 50, 100], fn: 'getProductOfferPage', status: 2,
        },
        offerform: {
          id: '', attachsName: '', attachsPath: '', disabled: false,
        },
        dialogFormVisible: false,
        dialogVisible: false,
        options: [],
        productOfferList: [],
      };
    },
    mounted(){
      // sessionStorage['/mydeclare'] = true;
      if(!sessionStorage[this.$route.path]){
        window.location.href = process.env.VUE_APP_API_URL;
      }
      //动态设置内容高度 让footer始终居底   header+footer的高度是100
      this.height = document.documentElement.clientHeight - 350;
      //监听浏览器窗口变化　
      window.onresize = ()=> {this.height = document.documentElement.clientHeight -350}
    },
    created() {
      this.initView();
      this.captchaUrl = this.getCaptchaUrl();
      this.uploadImgUrl = process.env.VUE_APP_API_URL + 'member/o_upload_image2.jspx';
      this.offerUploadUrl = process.env.VUE_APP_API_URL + 'member/o_upload_offer.jspx';
    },
    watch:{
      declareResult: {
        handler(obj){
          //初始赋值
          this.btnActive[3] = false;
          if(obj && obj.expiryDate.time > +new Date()){
            if(0 < obj.goodsNum){
              this.btnActive[3] = true; //选择品种
            }
          }
        },
        deep:true, //true 深度监听
        immediate: true, //初次赋值也监听
      },
    },
    methods: {
      selectable(d){
        return !d.checked;
      },
      thousandth(row, column, cellValue, index){
        if(cellValue && !isNaN(cellValue)){
          let str = new String(cellValue).split('.');
          let re = /\d{1,3}(?=(\d{3})+$)/g;
          let n1 = str[0].replace(re, "$&,");
          return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`;
        };
      },
      digit: function(num, length){
        var str = '';
        num = String(num);
        length = length || 2;
        for(var i = num.length; i < length; i++){
          str += '0';
        }
        return num < Math.pow(10, length) ? str + (num|0) : num;
      },
      toDateString: function(time, format){
        let date = new Date(time || new Date())
        ,ymd = [this.digit(date.getFullYear(), 4), this.digit(date.getMonth() + 1), this.digit(date.getDate())]
        ,hms = [this.digit(date.getHours()), this.digit(date.getMinutes()), this.digit(date.getSeconds())];
        format = format || 'yyyy-MM-dd HH:mm:ss';
        return format.replace(/yyyy/g, ymd[0]).replace(/MM/g, ymd[1]).replace(/dd/g, ymd[2]).replace(/HH/g, hms[0]).replace(/mm/g, hms[1]).replace(/ss/g, hms[2]);
      },
      changCaptcha: function() {
        this.captchaUrl = this.getCaptchaUrl();
      },
      getCaptchaUrl: function() {
        return process.env.VUE_APP_API_URL+'captcha.svl?d='+new Date().getTime()
      },
      initView(){
        setTimeout(() => {
          const self = this
          self.submitButtonLoading = true;
          self.getDeclareResult({ stype: 'DECLARE' }).then(res => {
            self.handleDeclareResult(res, 'DECLARE')
            return self.getDeclareResult({stype: 'OFFER'})
          }).then(res => {
            self.handleDeclareResult(res, 'OFFER')
            let { status, pageNo, pageSize } = this.queryform;
            self.productOfferPage({ status, pageNo, pageSize })
            return self.productOfferPage({ status, pageNo, pageSize })
          }).then(res => {
            self.handleProductOfferPage(res)
            //不用审核直接可以质量评级、在线报价
            //return self.productPage({ status: 5, pageNo: 1, pageSize: 1000 })
            return self.productPage({ status: 2, pageNo: 1, pageSize: 1000 })
          }).then(res => {
            self.handleProductPage(res)
          }).catch(err => {
            console.info(err);
          })
        })
      },
      handleClick(tab, event){
        if(this[event]){
          this[event].call(this, tab);
        }
      },
      submitDiscount(d) {
        // d.visible = false;
        //提示用户是否保存
        const id = d.id;
        const userId = d.userId;
        const productId = d.productId;
        let privatePrice = d.privatePrice || '', declarePrice = d.declarePrice || '';
        // if(!discount || !declarePrice){
        //   this.$message({ message: '请先完成价格降幅和议价价格的填报！', offset: 200, type: 'error' });
        //   return;
        // }
        const validateNum = (num) => {
          let reg = /^([0]|([1-9][0-9]*)|(([0]\.\d{1,}|[1-9][0-9]*\.\d{1,})))$/
          if (!reg.test(num)) { return `应大于0！`; }
          reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
          if (!reg.test(num)) {
            return `应保留2位小数！`;
          }
          return false;
        }
        // let msg = validateNum(privatePrice);
        // if(msg){
        //   this.$message({ message: `阳光平台采购价${msg}`, offset: 200, type: 'error' });
        //   return;
        // }
        let msg = validateNum(declarePrice);
        if(msg){
          this.$message({ message: `集中议价报价${msg}`, offset: 200, type: 'error' });
          return;
        }
        if(Number(privatePrice) < Number(declarePrice)){
          this.$message({ message: `集中议价报价不高于阳光平台挂网价，请调整后提交！`, offset: 200, type: 'error' });
          return;
        }
        this.submitButtonLoading = true;
        this.$api.memberApi.submitReoffer({ id: id, userId: userId, privatePrice: privatePrice, declarePrice: declarePrice, status: 7 }).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              this.$message({ message: '保存成功！', offset: 200, type: 'success' });
              this.getProductPage();
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'error' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      getRowKeys(row) {
        return row.id
      },
      handlePagination(pageNo, pageSize, obj){
        if(this[obj] && typeof this[obj] !== 'function'){
          if(pageNo){
            this[obj].pageNo = pageNo;
          }
          if(pageSize){
            this[obj].pageSize = pageSize;
          }
          this[this[obj].fn] && this[this[obj].fn]();
        }
      },
      getDeclareResult: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.getDeclareResult(param).then(res => {
            this.submitButtonLoading = false;
            if(200 === res.status){
              if(200 === res.data.code){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      getProductPage: function(){
        this.submitButtonLoading = true;
        let{ status, pageNo, pageSize } = this.bargainform
        this.productPage({ status, pageNo, pageSize }).then(res => {
          this.handleProductPage(res)
        })
      },
      productPage: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.productDeclarePage(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleProductPage: function(res){
        this.bargainform.data = [];
        JSON.parse(res.data.data).forEach((d, index, arr) => {
          d.disabled = 'true';
          if(4 === d.status){
            d.statusName = '已失效'
            d.offerPrice = ''
          }else{
            d.statusName = 8 === d.status ? '已中选' : '可报价'
            d.offerPrice = 8 === d.status ? '' : d.winPrice
            d.winPrice = 8 === d.status ? d.winPrice : ''
          }
          if(d.confirmOn){
            d.offerDate = d.confirmOn.time
          }
          if(0 == d.declarePrice){
            d.declarePrice = null;
          }
          if(0 == d.privatePrice){
            d.privatePrice = null;
          }
          d.id = d.declareId
          // d.fn = (null != d.discount && '' != d.discount) ? 'editRow' : 'saveRow'
          // d.operate = (null != d.discount && '' != d.discount) ? '修改' : '保存'
          d.edit = (null != d.discount && '' != d.discount) ? true : false
          this.bargainform.data.push(d);
        });
        this.bargainform.total = res.data.count;
        this.productOfferList = [...JSON.parse(res.data.data)];
      },
      handleDeclareResult: function(res, type){
        if('DECLARE' === type){
          let array = JSON.parse(res.data.data);
          if(0 < array.length){
            this.declareResult = array[0];
            this.fileListOfferFile = [];
            if(!!array[0].attachsPath && !!array[0].attachsName){
              this.offerform.attachsName = array[0].attachsName;
              this.offerform.attachsPath = array[0].attachsPath;
              this.offerform.disabled = true;
              this.fileListOfferFile.push({ name: array[0].attachsName, url: array[0].attachsPath, response: {data: array[0].attachsPath}});
            }
          }
        }else if('OFFER' === type){
          let d = JSON.parse(res.data.data);
            if(0 < d.length){
              if(+new Date() > d[0].effectiveDate.time && +new Date() < d[0].expiryDate.time){
                this.btnActive[4] = false;
                if(this.offerform.disabled){
                  this.btnActive[4] = true;
                }
              }else{
                this.btnActive[4] = true;
                this.offerform.disabled = true;
              }
            }
        }
      },
      getBargainOnlinePage: function(){
        let { stype, pageNo, pageSize } = { ...this.bargainOnlineForm }
        this.bargainOnlineList({ stype, pageNo, pageSize }).then(res => {
          this.handleBargainOnlineList(res.data)
        })
      },
      bargainOnlineList: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.listDeclareResult(param).then(res => {
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleBargainOnlineList: function(res){
        this.bargainOnlineForm.data = []
        JSON.parse(res.data).forEach((w, index) => {
          const d = { id: w.id, producerName: w.companyName, goodsNum: w.goodsNum, offerDate: this.toDateString(w.createOn.time, 'yyyy-MM-dd HH:mm'), attachsName: w.attachsName }
          if(w.uploadOn && w.uploadOn.time >= w.createOn.time){
            d.uploadDate = this.toDateString(w.uploadOn.time, 'yyyy-MM-dd HH:mm')
          }
          d.statusName = '未上传'
          d.operate = '上传附件'
          d.fn = 'pdfAttachsUpload'
          if(w.attachsPath){
            d.attachsPath = w.attachsPath
            d.statusName = '已上传'
          }
          this.bargainOnlineForm.data.push(d)
        })
        this.bargainOnlineForm.total = res.data.count
      },
      getProductOfferPage: function(){
        this.submitButtonLoading = true;
        let { status, pageNo, pageSize } = this.queryform;
        this.productOfferPage({ status, pageNo, pageSize }).then(res => {
          this.handleProductOfferPage(res)
        })
      },
      productOfferPage: function(param){
        return new Promise(resolve => {
          this.$api.memberApi.productPage(param).then(res => {
            this.submitButtonLoading = false;
            if(res.status === 200){
              if(res.data.code === 200){
                resolve(res)
              }else{
                this.$message({ message: res.data.data, offset: 200, type: 'error' });
              }
            }else{
              this.$message.error(`服务忙，请稍后再试`);
            }
          }).catch(error => {
            this.submitButtonLoading = false;
          });
        })
      },
      handleProductOfferPage: function(res){
        this.queryform.data = [];
        // const data = typeof res.data.data || res.data;
        JSON.parse(res.data.data).forEach((d, index, arr)=>{
          if(this.btnActive[3]){
            if(d.confirmed){
              d.fn = 'getByAssess';
              if(!d.operator || 0 == d.operator){
                d.btnType = 'success';
                d.operate = '填报';
              }else{
                d.btnType = 'primary';
                d.operate = '修改';
              }
            }
          }
          if(!d.operator || 0 == d.operator){
            d.score = '';
          }
          this.queryform.data.push(d);
        });
        this.queryform.total = res.data.count;
      },
      getByAssess(d){
        //let param = { productId: this.product.productId, operator: this.operator, status: 3 };
        let param = { productId: this.product.productId, operator: this.operator, status: 0 };
        if(d){
          param.productId = d.id;
          param.operator = 0;
        }
        this.submitButtonLoading = true;
        this.$api.memberApi.getByAssess(param).then(response => {
          this.submitButtonLoading = false;
          if(response.status === 200){
            if(response.data.code === 200){
              if(response.data.data){
                let data = JSON.parse(response.data.data);
                this.goAssess(data);
              }
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'info' });
            }
          }else{
            this.$message.error(`服务忙，请稍后再试`);
          }
        }).catch(error => {
          this.submitButtonLoading = false;
        });
      },
      clearValidate(formName){
        this.$refs[formName].clearValidate();
      },
      goLogin(msg) {
        this.$message({ message: msg, offset: 200, type: 'error' });
        setTimeout(() => {
          this.submitButtonLoading = false;
          window.location.href = process.env.VUE_APP_API_URL;
        }, 1500)
      }
    }
  }
</script>
<style>
  .el-dialog__footer {
    text-align: center;
  }
  .el-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 12px 0;
  }
  .upload-left{
    text-align: left;
  }

  .register-wrapper-div{
    padding-top:10px;
    width: 750px;
    margin: 0 auto;
    background-color: #f8f8f8;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-radio{
    margin-right: 0;
  }
  .el-checkbox{
    margin-right: 5px;
  }
  .el-radio--mini.is-bordered {
    margin: 2px 0;
  }
  .el-divider--horizontal {
    margin: 10px 0;
  }
  .el-collapse-item__content{
    padding-bottom: 10px;
  }
  .el-alert--info.is-light{
    width: auto;
    height: 65%;
    margin-right: 15px;
  }
  .el-tag--plain{
    width: 130px;
    text-align: center;
    border: 0px solid #fff;
  }
  .radio-br{
    width: 75%
  }
  .radio-auto{
    float: left;
    margin-right: 10px;
  }
  .assess-score {
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/views/Member/MyDeclare.vue